
ADILF.define('css/css!adilf/apps/comments/css/styles',[],function(){});